import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'user-input2',
  templateUrl: './user-input2.component.html',
  styleUrls: ['./user-input2.component.css']
})
export class UserInput2Component {
    @Input() value: string;
    @Output() valueChange = new EventEmitter<string>();

    @Input("has-error") hasError: boolean;
    @Input() label: string;
    @Input() placeholder: string = "";

    @Input() size?: "sm" | undefined;
}
